import { ReactSVG } from "react-svg";
import styles from './crown.module.css'
import React, { CSSProperties, useMemo } from "react";

type Props = {
    className?: string;
    style?: CSSProperties;
};

export default function GamesListCrown(
    {
        className,
        style,
    }: Props,
): React.ReactNode {
    const classNames = useMemo(
        () => [styles.crown, className]
            .filter(Boolean)
            .join(' '),
        [className],
    );

    return <ReactSVG
        className={classNames}
        src="/images/crown-icon.svg"
        style={style}
    />;
}
